import LdSearchFilter from 'lion-vue-shared/components/LdSearchFilter/SearchFilters';
import { HC_PROPS, initHCProps } from '../index';

export { initHCProps, HC_PROPS };
export default LdSearchFilter;
